<div mat-dialog-content class="signed-in-dialog">
  @if (authenticator.user) {
  <p>Signed in as:</p>
  <p>{{ authenticator.user.username }}</p>
  <div mat-dialog-actions>
    <button mat-raised-button color=primary mat-dialog-close (click)="authenticator.signOut()">Sign
      Out</button>
  </div>
  }
</div>